type Size = { width: number; height: number };

export type CropBoxLimits = {
   minCropBoxWidth: number;
   minCropBoxHeight: number;
   /** False once the minimum box fills the preview both ways, so the box can neither shrink nor move. */
   canCropSmaller: boolean;
};

// Mirrors cropperjs's own floor (never below 100 preview px) so this
// matches what createCropper() actually hands to Cropper.
function minCropBoxSide(minSide: number, sourceSide: number, thumbSide: number): number {
   return Math.max(Math.ceil((minSide / sourceSide) * thumbSide), 100);
}

/** The crop box limits image_crop.js passes to cropperjs, and whether they leave any room to crop. */
export function cropBoxLimits(source: Size, min: Size, thumb: Size): CropBoxLimits {
   const minCropBoxWidth = minCropBoxSide(min.width, source.width, thumb.width);
   const minCropBoxHeight = minCropBoxSide(min.height, source.height, thumb.height);
   return {
      minCropBoxWidth,
      minCropBoxHeight,
      canCropSmaller: minCropBoxWidth < thumb.width || minCropBoxHeight < thumb.height,
   };
}
